import $ from "jquery";

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

window.theme.customerLogin = (function () {
	let config = {
		recoverPassword: "#RecoverPassword",
		hideRecoverPasswordLink: "#HideRecoverPasswordLink",
		recoverPasswordForm: ".customer-page__form-recover",
		resetEmailField: "#RecoverEmail",
		recoverSubmit: "#RecoverSubmit"
	};

	if (!$(config.recoverPassword).length) {
		return;
	}

	checkUrlHash();
	resetPasswordSuccess();

	$(config.recoverPassword).on("click", (evt) => {
		$("body,html").animate(
			{
				scrollTop: 0
			},
			500
		);
		onShowHidePasswordForm(evt);
	});
	$(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

	$(config.resetEmailField).on("input", ({ currentTarget }) => {
		validateResetField(currentTarget.value)
			? $(config.recoverSubmit).attr("disabled", false)
			: null;
	});
	/*eslint-disable */
	function validateResetField(value) {
		return value.match(
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
	}
	/*eslint-enable */
	function onShowHidePasswordForm(evt) {
		evt.preventDefault();
		toggleRecoverPassword();
	}

	function checkUrlHash() {
		let hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === "#recover") {
			toggleRecoverPassword();
		}
	}

	/**
	 *  Show/Hide recover password form
	 */
	function toggleRecoverPassword() {
		$("#recoverPassword").toggleClass("hide");
		$("#CustomerLoginForm").toggleClass("hide");
	}

	/**
	 *  Show reset password success message
	 */
	function resetPasswordSuccess() {
		let $formState = $(".reset-password-success");

		// check if reset password form was successfully submited.
		if (!$formState.length) {
			return;
		}

		// show success message
		$("#ResetSuccess").removeClass("hide");
	}
})();
